"use strict";

exports.__esModule = true;
exports.SingleDeviceGridWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _EditableSingleDeviceGrid = require("./EditableSingleDeviceGrid");
var _SingleDeviceGridHeader = require("./SingleDeviceGridHeader");
var _SingleDeviceGrid = require("./SingleDeviceGrid");
var _SingleDeviceGridFields = require("./SingleDeviceGridFields");
var _Grid = require("../Grid");
var _reactIntl = require("react-intl");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var SingleDeviceGridWidget = exports.SingleDeviceGridWidget = {
  name: "SingleDeviceGrid",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "SingleDeviceGridWidget.label",
    defaultMessage: "Single Device Grid"
  }),
  group: _widgetGroups.LAYOUT_WIDGET,
  icon: "heat-grid",
  createElement: function createElement(props) {
    return {
      type: "SingleDeviceGrid",
      props: Object.assign({
        width: 200,
        height: 300,
        device: "",
        rowCount: 12,
        columnCount: 12
      }, props),
      children: []
    };
  },
  isParent: true,
  showInPalette: true,
  requiresContexts: [],
  suppliesContexts: ["device"],
  optionalProps: ["onClickAction"],
  requiresProps: ["x", "y", "width", "height"],
  suppliesProps: ["x", "y", "width", "height"],
  propConstraints: {
    width: {
      "default": 256,
      min: 256,
      max: 3840
    },
    height: {
      "default": 128,
      min: 256,
      max: 2160
    }
  },
  components: {
    Header: _SingleDeviceGridHeader.SingleDeviceGridHeader,
    Element: _SingleDeviceGrid.SingleDeviceGrid,
    Fields: _SingleDeviceGridFields.SingleDeviceGridFields,
    Editable: _EditableSingleDeviceGrid.EditableSingleDeviceGridElement,
    Thumbnail: _Grid.GridThumbnail
  }
};